<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div v-if="data" class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button @click="close()" type="button" class="close" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4 class="modal-title">
						Pedidos de proveedores
					</h4>
				</div>
				<div class="modal-body">
					<div v-if="data.providers" class="row">
						<div v-if="data.providers.length" class="col-md-12">
							<ul class="nav nav-tabs" role="tablist" id="tabs-providers">
								<template v-for="(provider, key) in data.providers">
									<template v-if="provider.orders.length">
										<li :id="'li-provider-' + provider.id" role="presentation">
											<a :href="'#provider-' + provider.id" :aria-controls="provider.name" role="tab" data-toggle="tab" aria-expanded="true">
												{{ provider.name }}
											</a>
										</li>
									</template>
									<template v-else>
										<li :id="'li-provider-' + provider.id" class="dropdown" role="presentation">
											<a aria-controls="myTabDrop1-contents" data-toggle="dropdown" class="dropdown-toggle" :id="'myTabDropProvider-' + provider.id" href="#" aria-expanded="false">
												{{ provider.name }}
												<span class="caret"></span>
											</a>
											<ul :id="'myTabDropProviderContents-' + provider.id" :aria-labelledby="provider.name" class="dropdown-menu">
												<li class="">
													<a @click="generateOrderProvider(provider)" :id="'btn-generate-order-provider'- + provider.id" data-toggle="tab" role="tab" href="javascript:void(0)" aria-expanded="true">
														Generar Pedido
													</a>
												</li>
											</ul>
										</li>
									</template>
								</template>
							</ul>
							<div class="tab-content" id="tabs-provider-content">
								<div v-for="(provider, key) in data.providers" role="tabpanel" class="tab-pane fade" :id="'provider-' + provider.id">
									<template v-if="provider.orders">
										<template v-if="provider.orders.length">
											<table class="table table-hover table-striped table-condensed">
												<thead>
													<tr>
														<th>{{ $platform.setting.number_symbol }}</th>
														<th>Base</th>
														<th>Impuestos</th>
														<th>Importe</th>
														<th>Total</th>
														<th>Estado</th>
														<th>Autor</th>
														<th>Fecha</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="order in provider.orders">
														<td>
															<router-link @click.native="close" :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/orders/' + order.id">
																{{ order.id }}
															</router-link>
														</td>
														<td>
															{{ order.base_amount }}
														</td>
														<td>
															{{ order.taxes }}
														</td>
														<td>
															{{ order.amount }}
														</td>
														<td>
															{{ order.total }}
														</td>
														<td>
															<label :class="'label label-' + order.status.class">
																<span v-if="order.status.lang">
																	{{ order.status.lang.name }}
																</span>
																<span v-else>
																	{{ order.status.name }}
																</span>
															</label>
														</td>
														<td>
															<router-link
															v-if="order.author"
															:to="'users/' + order.author_id">
																<span v-if="order.author.profile">
																	<img
																		v-if="order.author.profile.avatar"
																		:title="order.author.email"
																		:src="order.author.profile.avatar"
																		class="img-circle" width="30">
																	<i v-else :title="order.author.email" aria-hidden="true" class="fa fa-user-circle-o"></i>
																</span>
															</router-link>
														</td>
														<td>
															{{ order.created_at | moment }}
														</td>
													</tr>
												</tbody>
											</table>
										</template>
									</template>
									<div class="clearfix"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button @click="close()" type="button" class="btn btn-default">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	export default {
		props: ['user', 'isAuth', 'data'],
		data () {
			return {
				modal: {
					selector: 'modal-order-providers-' + Math.floor(Math.random() * 736456),
				},
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
			},
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
				this.clearActive()
				this.initActiveTabs()
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			generateOrderProvider(provider) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.purchase_order_will_be_added"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						var data = {
							tax_id: that.data.tax_id,
							currency_id: that.data.currency_id,
							lang_id: that.data.lang_id,
							parent_id: that.data.id,
							provider_id: provider.id,
						}
						return new Promise(function (resolve) {
							that.$http.post('admin/management/orders', data)
							.then(response => {
								var order = response.body.data
								provider.orders.push(order)
								that.$emit('reload')
								that.close()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
			clearActive() {
				$("#tabs-providers li").removeClass("active")
				$("#tabs-provider-content div").removeClass("active in")
			},
			initActiveTabs() {
				$("#tabs-providers li:first").addClass("active").show()
				$("#tabs-provider-content div:first").addClass("active in").show()
			}
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/management/orders/views/Providers.vue